/* eslint-disable no-undef */
import * as React from 'react'
import uuid from 'react-uuid'
import { Marker } from '@react-google-maps/api'
import { useDispatch, useSelector } from 'react-redux'
import {
  fetchVehiclePositions,
  handleVehicleClicked,
} from '../Map/redux/myMapsSlice'
import { VEHICLEMARKER } from '../../utils/constants'
import { logMapEvent } from '../../utils/events'

function Vehicles() {
  const dispatch = useDispatch()
  const { selectedRoute, vehiclesForStop, selectedVehicle } = useSelector(
    (s) => s.maps,
  )

  // eslint-disable-next-line consistent-return
  React.useEffect(() => {
    if (vehiclesForStop && vehiclesForStop.length > 0) {
      const interval = setInterval(() => {
        dispatch(fetchVehiclePositions())
      }, 10000)
      return () => {
        clearInterval(interval)
      }
    }
  }, [vehiclesForStop, selectedRoute, dispatch])

  const getVehicleInfo = (vehicle) => {
    logMapEvent(dispatch, VEHICLEMARKER, vehicle.vehicle.id)
    dispatch(handleVehicleClicked(vehicle))
  }
  return (
    <div>
      {vehiclesForStop &&
        vehiclesForStop.length > 0 &&
        vehiclesForStop.map((vehicle) => (
          <Marker
            onClick={() => getVehicleInfo(vehicle)}
            zIndex={10000}
            key={uuid()}
            position={{
              lat: vehicle.position.latitude,
              lng: vehicle.position.longitude,
            }}
            icon={{
              path: 'M502.69,867.5h-9a16.76,16.76,0,0,0-4-1c-17.33.25-34.47-1.52-51.64-3.89A393.32,393.32,0,0,1,372,847.57,413.21,413.21,0,0,1,108,589.38c-7-20.33-12.87-41-15.87-62.31-2.09-14.89-4.58-29.76-5.76-44.73-1-12.11-.58-24.37-.1-36.53.59-15,1.27-30,3.07-44.82a334.66,334.66,0,0,1,7.79-43.25c4.49-17.42,10.17-34.58,16.06-51.59,9-26,22-50.07,36.64-73.32a368.14,368.14,0,0,1,44.8-58.23A530.12,530.12,0,0,1,240.35,132a310.06,310.06,0,0,1,42.13-29.24,652.58,652.58,0,0,1,58.69-30.07c21-9.51,43.27-16,65.91-20.78,12.27-2.56,24.68-4.51,37.09-6.36,7.3-1.09,14.69-1.58,22.06-2.07,11.84-.79,23.7-1.81,35.55-1.85a290.86,290.86,0,0,1,30.06,1.91c14.33,1.44,28.89,2.13,42.86,5.29,21.82,4.94,43.52,10.85,64.76,17.88,28.41,9.39,54.92,23.09,80.13,39.27a430.94,430.94,0,0,1,55,41.88,386.44,386.44,0,0,1,46,48.48c10.68,13.54,20.28,28,29.65,42.49,12.06,18.66,21.71,38.62,30.12,59.2,8.63,21.12,15.84,42.69,20.27,65.06,3.39,17.11,6.27,34.35,8.44,51.64,1.31,10.46.81,21.15,1.22,31.74a27,27,0,0,0,1,4.52v7a16.76,16.76,0,0,0-1,4c.26,17.66-1.45,35.13-3.88,52.63a406.9,406.9,0,0,1-46.21,138.63A416.33,416.33,0,0,1,802.7,733.6a382.91,382.91,0,0,1-55.64,50.58c-24.53,18.19-50.52,34-78.54,46.45a416.79,416.79,0,0,1-78,26.06c-27.63,6.2-55.44,10.12-83.8,9.86A17.25,17.25,0,0,0,502.69,867.5ZM495.55,804c95.84-1,176.64-33,243.77-97.09C805.5,643.75,842.11,565.58,847,474.15c5.32-100.32-27.1-188.08-96.45-260.85-63.12-66.22-141.36-102.75-232.8-107.57-100.33-5.29-188.07,27.16-260.81,96.54C190.58,265.55,154.1,344,149.41,435.6c-5.13,100.17,27.26,187.82,96.67,260.25C314.51,767.25,399.3,802.76,495.55,804Z M786.62,441.2c3,81.05-22.29,153-79.18,213S579.83,744,497.71,744.29c-79.45.27-148.65-28.36-204.85-84.6s-84.6-125.45-84.5-204.91c.11-79.63,28.66-148.85,85.23-205.11,56.16-55.85,125.06-83.53,204.11-84.07a279.76,279.76,0,0,1,140,35.82c44.35,24.73,80.14,58.71,106.75,102C770.11,345.31,784.1,390.86,786.62,441.2Zm-289-226.89c-7.94-1.25-13.86,3.42-17.72,10-4.41,7.53-7.71,15.74-11.07,23.84-8.79,21.17-17.28,42.46-26,63.64-9.24,22.41-18.73,44.72-27.93,67.15-10,24.36-19.68,48.86-29.7,73.21-11.58,28.13-23.47,56.12-35.07,84.24-10.54,25.55-20.81,51.22-31.31,76.79-4.29,10.44-2.19,18.89,7.2,27.21,6.19,5.47,17.43,6,25.26,1.48q31.31-18.14,62.72-36.09,39.25-22.49,78.54-44.89c3.69-2.11,7.11-2.84,11-.14,2.91,2,6.31,3.38,9.42,5.17q37.1,21.33,74.16,42.71,29,16.65,58.06,33.21c7.85,4.5,18.35,4.24,24.94-1.19,9-7.41,12-16.77,8.18-26.26-5.46-13.58-11.12-27.08-16.77-40.58-7.92-18.91-16.06-37.73-23.84-56.69-9.75-23.76-19.12-47.67-28.85-71.43-9.87-24.09-20.06-48-30-72.1-9.58-23.31-19-46.71-28.46-70.05-9.63-23.64-19.16-47.32-29-70.86C516.24,220.52,510.82,213.87,497.63,214.31Z',
              anchor: new google.maps.Point(600, 600),
              fillColor: selectedRoute ? selectedRoute.route_color : '#cc0033',
              fillOpacity: 1,
              strokeColor: selectedRoute
                ? selectedRoute.route_color
                : '#cc0033',
              strokeWeight: 1,
              scale:
                selectedVehicle?.vehicle?.id === vehicle.vehicle.id
                  ? 0.05
                  : 0.03,
              rotation: vehicle.position.bearing,
            }}
          >
            <Marker
              zIndex={1000}
              position={{
                lat: vehicle.position.latitude,
                lng: vehicle.position.longitude,
              }}
              icon={{
                path: 'M255,0C114.75,0,0,114.75,0,255s114.75,255,255,255s255-114.75,255-255S395.25,0,255,0z',
                anchor: new google.maps.Point(350, 366),
                fillColor: selectedRoute
                  ? selectedRoute.route_text_color
                  : '#000000',
                fillOpacity: 1,
                strokeColor: selectedRoute
                  ? selectedRoute.route_text_color
                  : '#000000',
                strokeWeight: 1,
                scale:
                  selectedVehicle?.vehicle?.id === vehicle.vehicle.id
                    ? 0.07
                    : 0.04,
                rotation: vehicle.position.bearing,
              }}
            />
          </Marker>
        ))}
    </div>
  )
}

export default Vehicles
